const root = document.getElementById('root') as HTMLElement;

export const scrollToTop = () => {
  root.scrollTo(0, 0);
}

export const scrollUnderHeader = () => {
  root.scrollTo(0, window.innerHeight)
}